import { Footer } from '../components/Layout/Footer';
import { AccountDeletedNotice } from '../components/Welcome/AccountDeletedNotice';
import { Welcome } from '../components/Welcome/Welcome';

export function HomePage() {
  return (
    <>
      <AccountDeletedNotice />
      <Welcome />
      <Footer />
    </>
  );
}
